import { z } from "zod";

import { ReplayTypeEnum } from "@classview/shared-types";

const startTrialSchema = z.object({
  newReplayVersion: z.nativeEnum(ReplayTypeEnum),
  date: z.object({
    from: z.date(),
    to: z.date(),
  }),
});
type StartTrialFormData = z.infer<typeof startTrialSchema>;

export { startTrialSchema };
export type { StartTrialFormData };
